import { useState, useEffect } from 'react';
import { C } from '../../constants/colors.js';
import { N } from '../../constants/fonts.js';

const LOADING_TIPS = [
  "🐬 Finley is writing something just for you...",
  "📚 Did you know? Dolphins are one of the smartest animals!",
  "✨ Your story is being created right now...",
  "🌊 Finley is diving deep to find the perfect words...",
  "🎯 Almost ready! Finley is making this just your level...",
  "🐬 Fun fact: Dolphins sleep with one eye open!",
  "📖 Great readers are made one page at a time...",
  "🌟 Finley is picking the best words for you..."
];

export function LoadingDots({ msg }) {
  const [tipIdx, setTipIdx] = useState(() => Math.floor(Math.random() * LOADING_TIPS.length));
  const [fade, setFade] = useState(true);
  useEffect(() => {
    const iv = setInterval(() => {
      setFade(false);
      setTimeout(() => { setTipIdx(i => (i + 1) % LOADING_TIPS.length); setFade(true); }, 300);
    }, 4000);
    return () => clearInterval(iv);
  }, []);
  return (
    <div style={{textAlign:"center",padding:"24px 0"}}>
      <div style={{fontSize:56,marginBottom:12,animation:"float 2s ease-in-out infinite"}}>{"🐬"}</div>
      <div style={{fontFamily:N,fontSize:15,color:C.textMid,minHeight:24,opacity:fade?1:0,transition:"opacity 0.3s ease",marginBottom:12}}>{LOADING_TIPS[tipIdx]}</div>
      <div style={{display:"flex",gap:10,justifyContent:"center",alignItems:"center",marginBottom:8}}>
        {["#FF6B35","#7B2FBE","#4ADE80"].map((color,i) => (
          <div key={i} style={{width:10,height:10,borderRadius:"50%",background:color,animation:`rqLoadBounce 1.2s ease-in-out ${i*0.15}s infinite`}}/>
        ))}
      </div>
      {msg && <div style={{fontFamily:N,fontSize:13,color:C.textLight}}>{msg}</div>}
    </div>
  );
}
